/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_RecommendedInputs */

const en_fc_dl_recommended = /** @type {(inputs: Fc_Dl_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Fc_Dl_RecommendedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_recommended = /** @type {((inputs?: Fc_Dl_RecommendedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_RecommendedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_recommended(inputs)
});
export { fc_dl_recommended as "fc.dl.recommended" }